import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Spinner } from '../../../../../common/index.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { EduCourseDetailPage as EduCourseDetailContent } from '../../../../../common/FriEdu/EduCourseDetailPage.jsx';
import { useGetEduCourseQuery } from '../../../../../../redux/services/eduCourses.jsx';
import useIsUserAdmin from '../../../../../../hooks/useIsUserAdmin.jsx';
import { useIsUserAuthorOfEduCourse } from '../../../../../../hooks/useIsUserAuthorOfEduCourse.jsx';

export const EduCourseDetailPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const { data: courseDetail, isLoading, refetch } = useGetEduCourseQuery(id);

  // Set CMS page title
  useEffect(() => {
    document.title = 'FRI.edu - ' + t('Detail kurzu');
  }, [t]);

  const isAdmin = useIsUserAdmin();
  const { isAuthor } = useIsUserAuthorOfEduCourse(courseDetail?.lecturerable);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Informácie o kurze')}
        backUrl={-1}
        backUrlTooltip={t('Zoznam kurzov')}
        permissionsBasic={'fri-edu-courses'}
      />
      <div style={{ margin: '10px' }}>
        <EduCourseDetailContent
          courseDetail={courseDetail}
          showDatesSection={false}
          isAdmin={isAdmin}
          isAuthor={isAuthor}
          canUpdate={false}
          onRefetchCourses={refetch}
        />
      </div>
    </>
  );
};

export default EduCourseDetailPage;
